import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { signout as manager } from '@/service/api/manager'

export default {
  components: { cSwitch },
  data : () => ({
    confirm_continue: false,
    confirm_end: false,
    add: false,
    lock: true,
    model : { is_use: true, is_active: true, is_del: true},
    allowed: false,
  }),
  computed: { },
  methods: {
    list() { this.$router.push({ name: 'signout' }); this.$emit('refresh'); },
    async get({ id, tag } = this.$route.params) {
      console.log('signup.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try{
        this.add = false;
        this.lock = (tag != 'edit');
        let rs = await manager.detailSignout({ id : id })
        if(!rs.error) {
          this.model = Object.assign({ group: {} }, this.model, rs.body)
          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
        } else {
          this.$toastr.e("signup user", 'load failed');
          this.list(); this.$emit('refresh');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async service_continue(){
      try{
        let rs = await manager.continueService(this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Processed failed')  }
        this.$toastr.s('Processed.');
        this.model.is_del = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    async service_end(){
      try{
        let rs = await manager.endService(this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Processed failed')  }
        this.$toastr.s('Processed', "done");
        this.model.is_del = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('signout_detail.vue', 'created'); },
  destroyed() { console.log('signout_detail.vue', 'destroyed'); },
  mounted() {
    console.log('signout_detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}